/* eslint-disable */

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { withStyles } from 'material-ui/styles';
import Input, { InputLabel } from 'material-ui/Input';
import Card, { CardHeader, CardContent } from 'material-ui/Card';
import { FormControl } from 'material-ui/Form';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from 'material-ui/Table';
import green from 'material-ui/colors/green';
import { CircularProgress } from 'material-ui/Progress';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import Button from 'material-ui/Button';

import TodayIcon from 'material-ui-icons/Today';

import { FiDownload } from 'react-icons/fi';
import { FaBroadcastTower } from 'react-icons/fa';

import truckIcon from '../assets/images/icons/truck.png';
import charityIcon from '../assets/images/icons/charity.png';
import filterIcon from '../assets/images/icons/filter.png';

import Grid from 'material-ui/Grid';
import List, { ListItem, ListItemText, ListItemAvatar } from 'material-ui/List';
import windTurbineIcon from '../assets/images/wind_turbine_icon.png';
import hydroDamIcon from '../assets/images/hydro_dam_icon.png';
import Avatar from 'material-ui/Avatar';
import { withRouter } from 'react-router';
import { lighten } from 'material-ui/styles/colorManipulator';

import Dialog from 'material-ui/Dialog/Dialog';
import DialogActions from 'material-ui/Dialog/DialogActions';
import DialogContent from 'material-ui/Dialog/DialogContent';
import DialogTitle from 'material-ui/Dialog/DialogTitle';

import moment from 'moment';
import { CSSTransitionGroup } from 'react-transition-group';
import * as XLSX from 'xlsx';
import InfiniteCalendar from 'react-infinite-calendar';
import 'react-infinite-calendar/styles.css';

import {
  getTransportCertificatesStart,
  sortTransportCertificates,
  changePageTransportCertificates,
  changeRowsPerPageTransportCertificates,
  filterDateTextChanged,
  filterProductTextChanged,
  filterTextChanged,
  filterSpTextChanged,
  filterShTextChanged,
  toggleFilter,
  toggleStartDateDialog,
  toggleEndDateDialog,
  setStartDate,
  setEndDate,
  generateTransportCertificatePdf,
} from '../actions';

import certificateLogo from '../assets/images/certificate.png';
import { translate } from 'react-i18next';

let counter = 0;

function createData(name, id, fat, carbs, protein) {
  counter += 1;
  return { id: counter, name, id, fat, carbs, protein };
}

class TransportCertificatesHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy, t } = this.props;

    let columnData = [
      {
        id: 'Bon de livraison',
        numeric: true,
        disablePadding: false,
        label: 'Delivery Id',
      },
      { id: 'date', numeric: false, disablePadding: false, label: 'Date' },
      {
        id: 'Produit',
        numeric: false,
        disablePadding: false,
        label: 'Product',
      },
      {
        id: 'co2SavedTemp',
        numeric: true,
        disablePadding: false,
        label: 'Avoided CO2 : Certified by Attributes',
      },
      {
        id: 'co2SavedGoo',
        numeric: true,
        disablePadding: false,
        label: 'Avoided CO2 : Traditional GOs',
      },
      {
        id: 'co2Emissions',
        numeric: true,
        disablePadding: false,
        label: 'Scope 3 : Transport CO2 emissions',
      },
      { id: '__EMPTY_1', numeric: false, disablePadding: false, label: 'Site' },
      {
        id: 'curstomerSiteId',
        numeric: false,
        disablePadding: false,
        label: 'Site Id',
      },
      {
        id: 'curstomerSiteCity',
        numeric: false,
        disablePadding: false,
        label: 'Site city',
      },
      {
        id: '__EMPTY_3',
        numeric: false,
        disablePadding: false,
        label: 'Customer',
      },
      {
        id: 'curstomerId',
        numeric: false,
        disablePadding: false,
        label: 'Customer Id',
      },
      { id: '', numeric: false, disablePadding: false, label: 'Download PDF' },
    ];

    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                padding={column.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === column.id ? order : false}
              >
                <Tooltip
                  title={t('Sort')}
                  placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                  >
                    {t(column.label)}{' '}
                    {t(column.id) === 'co2SavedGoo' ||
                    t(column.id) === 'co2SavedTemp' ||
                    t(column.id) === 'co2Emissions'
                      ? '(kg)'
                      : ''}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

TransportCertificatesHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
});

const exportDeliveries = (deliveries, props) => {
  //
  //
  const { t } = props;
  let dataToExport = [
    [
      'Delivery ID',
      'Date',
      'Product',
      t('Avoided CO2 : Certified by Attributes') + ' (kg)',
      t('Avoided CO2 : Traditional GOs') + ' (kg)',
      t('Scope 3 : Transport CO2 emissions') + ' (kg)',
      'Site Name',
      'Site ID',
      'Site city',
      'Customer Name',
      'Customer ID',
    ],
  ];

  for (let i = 0; i < deliveries.length; i++) {
    const exportLine = [
      deliveries[i]['Bon de livraison'],
      deliveries[i].date,
      deliveries[i].Produit,
      parseInt(deliveries[i].co2SavedTemp, 10),
      parseInt(deliveries[i].co2SavedGoo, 10),
      parseInt(deliveries[i].co2Emissions, 10),
      deliveries[i]['__EMPTY_1'],
      deliveries[i].curstomerSiteId,
      deliveries[i].curstomerSiteCity,
      deliveries[i]['__EMPTY_3'],
      deliveries[i].curstomerId,
    ];
    dataToExport.push(exportLine);
  }
  // BUILD SHEET
  if (dataToExport && dataToExport.length > 0) {
    /* generate worksheet */
    const ws = XLSX.utils.aoa_to_sheet(dataToExport);

    /* generate workbook and add the worksheet */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'attributes-data-export-deliveries.xlsx');
  }
};

let TransportCertificatesToolbar = props => {
  const { numSelected, classes, loading, toggleFilter, deliveries, t } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="title">
            <img
              src={truckIcon}
              style={{
                maxHeight: 20,
                position: 'relative',
                top: 3,
                marginRight: 10,
              }}
            />
            {t('Customer deliveries')}
            {loading && (
              <CircularProgress size={16} style={{ marginLeft: 10 }} />
            )}
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        <Tooltip title={t('Filter list')}>
          <IconButton aria-label="Filter list" onClick={() => toggleFilter()}>
            <img src={filterIcon} style={{ maxHeight: 20 }} />
          </IconButton>
        </Tooltip>
      </div>
      <div className={classes.actions}>
        <Tooltip title={t('Export data')}>
          <IconButton
            aria-label="Export data"
            onClick={() => exportDeliveries(deliveries, props)}
          >
            <FiDownload style={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </div>
    </Toolbar>
  );
};

TransportCertificatesToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

TransportCertificatesToolbar = withStyles(toolbarStyles)(
  TransportCertificatesToolbar
);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  buttonProgress: {
    color: green[500],
    position: 'relative',
    bottom: -30,
    left: 100,
    marginTop: -12,
    marginLeft: -12,
  },
  button: {
    margin: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  filterEnter: {
    opacity: 0.01,
    filterEnterActive: {
      opacity: 1,
      transition: 'opacity 500ms ease-in',
    },
  },
  filterLeave: {
    opacity: 1,
    filterLeaveActive: {
      opacity: 0.01,
      transition: 'opacity 300ms ease-in',
    },
  },
});

class TransportCertificates extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      order: 'asc',
      orderBy: 'id',
      selected: [],
      data: [
        createData('Frasnes', 0, 3.7, 67, 4.3),
        createData('Fontanelles', 1, 25.0, 51, 4.9),
        createData('Eget', 2, 16.0, 24, 6.0),
        createData('Burgum', 3, 6.0, 24, 4.0),
        createData('Marèges', 4, 16.0, 49, 3.9),
      ].sort((a, b) => (a.id < b.id ? -1 : 1)),
      page: 0,
      rowsPerPage: 5,
      open: false,
      items: ['hello', 'world', 'click', 'me'],
    };
  }

  handleFilterTextChange = () => event => {
    this.props.filterTextChanged(event.target.value);
  };

  handleFilterDateTextChange = () => event => {
    this.props.filterDateTextChanged(event.target.value);
  };

  handleFilterProductTextChange = () => event => {
    this.props.filterProductTextChanged(event.target.value);
  };

  handleFilterSpTextChange = () => event => {
    this.props.filterSpTextChanged(event.target.value);
  };

  handleFilterShTextChange = () => event => {
    this.props.filterShTextChanged(event.target.value);
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleDownloadPdf = delivery => {
    this.props.generateTransportCertificatePdf(delivery);
  };

  componentDidMount = () => {
    if (!this.props.isAuthenticated) {
      this.props.history.push('/');
    } else {
      this.props.getTransportCertificatesStart();
    }
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.props.orderBy === property && this.props.order === 'desc') {
      order = 'asc';
    }

    const transportCertificates =
      order === 'desc'
        ? this.props.transportCertificates.sort((a, b) => {
            if (orderBy === 'date') {
              return moment(b[orderBy], 'DD/MM/YYYY').toDate() <
                moment(a[orderBy], 'DD/MM/YYYY').toDate()
                ? -1
                : 1;
            }
            return b[orderBy] < a[orderBy] ? -1 : 1;
          })
        : this.props.transportCertificates.sort((a, b) => {
            if (orderBy === 'date') {
              return moment(a[orderBy], 'DD/MM/YYYY').toDate() <
                moment(b[orderBy], 'DD/MM/YYYY').toDate()
                ? -1
                : 1;
            }
            return a[orderBy] < b[orderBy] ? -1 : 1;
          });

    this.props.sortTransportCertificates(transportCertificates, order, orderBy);
  };

  handleChangePage = (event, page) => {
    this.props.changePageTransportCertificates(page);
  };

  //Below are functions provided initially by material ui
  //Visit https://material-ui-next.com/demos/tables/#sorting-amp-selecting for details

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState({ selected: this.state.data.map(n => n.id) }); //Do this redux way
      return;
    }
    this.setState({ selected: [] }); //Do this redux way
  };

  handleChangeRowsPerPage = event => {
    this.props.changeRowsPerPageTransportCertificates(event.target.value);
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  handleClickStartDateOpen = startDate => {
    this.props.toggleStartDateDialog();
  };

  handleClickStartDateClose = () => {
    this.props.toggleStartDateDialog();
  };

  handleClickEndDateOpen = endDate => {
    this.props.toggleEndDateDialog();
  };

  handleClickEndDateClose = () => {
    this.props.toggleEndDateDialog();
  };

  renderForm() {
    const { classes, t } = this.props;
    const {
      filterText,
      filterProductText,
      filterShText,
      filterSpText,
      dialogStartDateOpen,
      dialogEndDateOpen,
      startDate,
      endDate,
    } = this.props;
    // Calendar dates
    //const today = new Date();
    //const lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);

    return (
      <div style={{ paddingLeft: 24, paddingBottom: 10 }}>
        <FormControl
          className={classNames(classes.margin, classes.textField)}
          style={{ margin: 10 }}
        >
          <InputLabel htmlFor="adornment-filter-text">
            {t('Delevery Id')}
          </InputLabel>
          <Input
            id="adornment-filter-text"
            type="text"
            value={filterText ? filterText : ''}
            autoComplete="filterText"
            onChange={this.handleFilterTextChange()}
          />
        </FormControl>
        <FormControl
          className={classNames(classes.margin, classes.textField)}
          style={{ margin: 10 }}
        >
          <InputLabel htmlFor="adornment-filtersh-text">
            {t('Site id or name')}
          </InputLabel>
          <Input
            id="adornment-filtersh-text"
            type="text"
            value={filterShText ? filterShText : ''}
            autoComplete="filterShText"
            onChange={this.handleFilterShTextChange()}
          />
        </FormControl>
        <FormControl
          className={classNames(classes.margin, classes.textField)}
          style={{ margin: 10 }}
        >
          <InputLabel htmlFor="adornment-filtersp-text">
            {t('Customer id or name')}
          </InputLabel>
          <Input
            id="adornment-filtersp-text"
            type="text"
            value={filterSpText ? filterSpText : ''}
            autoComplete="filterSpText"
            onChange={this.handleFilterSpTextChange()}
          />
        </FormControl>
        <FormControl
          className={classNames(classes.margin, classes.textField)}
          style={{ margin: 10 }}
        >
          <InputLabel htmlFor="adornment-filterproduct-text">
            {t('Filter by product')}
          </InputLabel>
          <Input
            id="adornment-filterproduct-text"
            type="text"
            value={filterProductText ? filterProductText : ''}
            autoComplete="filterProductText"
            onChange={this.handleFilterProductTextChange()}
          />
        </FormControl>
        <FormControl style={{ width: 167 }}>
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 26,
            }}
          >
            <Typography variant="caption" gutterBottom align="left">
              {t('Start')}
            </Typography>
          </div>
          <div style={{ marginTop: 5 }}>
            <Tooltip title="Start Date">
              <Button
                className={classes.button}
                onClick={() => this.props.toggleStartDateDialog()}
              >
                <TodayIcon
                  style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                  className={classNames(classes.leftIcon, classes.iconSmall)}
                />
                <Typography variant="caption" gutterBottom align="left">
                  {moment(startDate).format('DD/MM/YYYY')}
                </Typography>
              </Button>
            </Tooltip>
          </div>
        </FormControl>

        <FormControl style={{ width: 167 }}>
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 26,
            }}
          >
            <Typography variant="caption" gutterBottom align="left">
              {t('End')}
            </Typography>
          </div>
          <div style={{ marginTop: 5 }}>
            <Tooltip title="End Date">
              <Button
                className={classes.button}
                onClick={() => this.props.toggleEndDateDialog()}
              >
                <TodayIcon
                  style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                  className={classNames(classes.leftIcon, classes.iconSmall)}
                />
                <Typography variant="caption" gutterBottom align="left">
                  {moment(endDate).format('DD/MM/YYYY')}
                </Typography>
              </Button>
            </Tooltip>
          </div>
        </FormControl>
        <Dialog
          fullScreen={false}
          open={dialogStartDateOpen}
          onClose={this.props.toggleStartDateDialog}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">Start Date</DialogTitle>
          <DialogContent>
            <InfiniteCalendar
              width={400}
              height={600}
              display={'years'}
              selected={startDate}
              onSelect={selectedStartDate => {
                this.props.setStartDate(selectedStartDate);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.props.toggleStartDateDialog}
              color="primary"
              autoFocus
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          fullScreen={false}
          open={dialogEndDateOpen}
          onClose={this.props.toggleEndDateDialog}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">End Date</DialogTitle>
          <DialogContent>
            <InfiniteCalendar
              width={400}
              height={600}
              display={'years'}
              selected={endDate}
              onSelect={selectedEndDate => {
                this.props.setEndDate(selectedEndDate);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.props.toggleEndDateDialog}
              color="primary"
              autoFocus
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  renderTrackedAvoidedCo2Card() {
    const { classes, t, username } = this.props;

    if (username === 'airproducts') {
      return false;
    }

    return (
      <Grid item xs={12} sm={4}>
        <Card className={classes.card}>
          <CardHeader
            avatar={<FaBroadcastTower style={{ color: '#26A69A' }} />}
            title={t("Avoided CO2 : Certified On Attributes's blockchain")}
            subheader={t('Year to date')}
          />
          <CardContent>{this.renderTrackedAvoidedCo2()}</CardContent>
        </Card>
      </Grid>
    );
  }

  renderTrackedAvoidedCo2() {
    const { classes, t, loading, transportCertificatesComplete } = this.props;

    let avoidedCo2YTD = 0;
    transportCertificatesComplete.map(delivery => {
      avoidedCo2YTD += delivery.co2SavedTemp;
    });

    if (!avoidedCo2YTD || loading) {
      return <CircularProgress size={16} color="primary" />;
    }

    let avoidedCo2kg = parseInt(avoidedCo2YTD, 10);
    let avoidedCo2Ton = parseInt(avoidedCo2YTD / 1000, 10);

    let avoidedCo2Unit = 'kg';
    let avoidedCo2Converted = avoidedCo2kg;

    if (avoidedCo2YTD > 1000) {
      avoidedCo2Converted = avoidedCo2Ton;
      avoidedCo2Unit = t(' ton');
    }

    return (
      <Typography
        className={classes.title}
        variant="subheading"
        gutterBottom
        color="textSecondary"
        style={{ fontSize: '0.875rem' }}
      >
        <span style={{ fontSize: '1.2rem', color: '#F87733' }}>
          {avoidedCo2Converted}
        </span>{' '}
        {avoidedCo2Unit}
      </Typography>
    );
  }

  renderTotalAvoidedCo2Card() {
    const { classes, t, username } = this.props;

    if (username === 'airproducts') {
      return false;
    }

    return (
      <Grid item xs={12} sm={4}>
        <Card className={classes.card}>
          <CardHeader
            avatar={<img src={charityIcon} style={{ maxHeight: 20 }} />}
            title={t('Avoided CO2 : Traditional GOs')}
            subheader={t('Year to date')}
          />
          <CardContent>{this.renderTotalAvoidedCo2()}</CardContent>
        </Card>
      </Grid>
    );
  }

  renderTotalAvoidedCo2() {
    const { classes, t, loading, transportCertificatesComplete } = this.props;

    let avoidedCo2YTD = 0;
    transportCertificatesComplete.map(delivery => {
      avoidedCo2YTD += delivery.co2SavedGoo;
    });

    if (!avoidedCo2YTD || loading) {
      return <CircularProgress size={16} color="primary" />;
    }

    let avoidedCo2kg = parseInt(avoidedCo2YTD, 10);
    let avoidedCo2Ton = parseInt(avoidedCo2YTD / 1000, 10);

    let avoidedCo2Unit = 'kg';
    let avoidedCo2Converted = avoidedCo2kg;

    if (avoidedCo2YTD > 1000) {
      avoidedCo2Converted = avoidedCo2Ton;
      avoidedCo2Unit = t(' ton');
    }

    return (
      <Typography
        className={classes.title}
        variant="subheading"
        gutterBottom
        color="textSecondary"
        style={{ fontSize: '0.875rem' }}
      >
        <span style={{ fontSize: '1.2rem', color: '#F87733' }}>
          {avoidedCo2Converted}
        </span>{' '}
        {avoidedCo2Unit}
      </Typography>
    );
  }

  renderCo2EmissionsCard() {
    const { classes, t, username } = this.props;

    if (username === 'airproducts') {
      return false;
    }

    return (
      <Grid item xs={12} sm={4}>
        <Card className={classes.card}>
          <CardHeader
            avatar={<img src={truckIcon} style={{ maxHeight: 20 }} />}
            title={t('Scope 3 : Transport CO2 emissions')}
            subheader={t('Year to date')}
          />
          <CardContent>{this.renderCo2Emissions()}</CardContent>
        </Card>
      </Grid>
    );
  }

  renderCo2Emissions() {
    const { classes, t, loading, transportCertificatesComplete } = this.props;

    let co2EmissionsYTD = 0;
    transportCertificatesComplete.map(delivery => {
      co2EmissionsYTD += delivery.co2Emissions;
    });

    if (!co2EmissionsYTD || loading) {
      return <CircularProgress size={16} color="primary" />;
    }

    let co2Emissionskg = parseInt(co2EmissionsYTD, 10);
    let co2EmissionsTon = parseInt(co2EmissionsYTD / 1000, 10);

    let co2EmissionsUnit = 'kg';
    let co2EmissionsConverted = co2Emissionskg;

    if (co2EmissionsYTD > 1000) {
      co2EmissionsConverted = co2EmissionsTon;
      co2EmissionsUnit = t(' ton');
    }

    return (
      <Typography
        className={classes.title}
        variant="subheading"
        gutterBottom
        color="textSecondary"
        style={{ fontSize: '0.875rem' }}
      >
        <span style={{ fontSize: '1.2rem', color: '#F87733' }}>
          {co2EmissionsConverted}
        </span>{' '}
        {co2EmissionsUnit}
      </Typography>
    );
  }

  render() {
    const { classes } = this.props;
    const {
      transportCertificates,
      transportCertificatesComplete,
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      t,
      i18n,
    } = this.props;
    const emptyRows =
      rowsPerPage -
      Math.min(rowsPerPage, transportCertificates.length - page * rowsPerPage);

    let avoidedCo2YTD = 0;
    transportCertificatesComplete.map(delivery => {
      avoidedCo2YTD += delivery.co2SavedTemp;
    });

    let avoidedCo2YTDOld = 0;
    transportCertificates.map(delivery => {
      avoidedCo2YTDOld += delivery.co2SavedTemp;
    });

    return (
      <div className={classes.root}>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <List style={{ display: 'flex', flexDirection: 'row', padding: 0 }}>
              <NavLink
                to="/assets/prod/read/0"
                style={{ textDecoration: 'none' }}
              >
                <ListItem
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: 0,
                  }}
                >
                  <ListItemAvatar>
                    <Avatar
                      alt="Marèges"
                      src={hydroDamIcon}
                      className={classes.avatar}
                    />
                  </ListItemAvatar>
                  <ListItemText secondary="Marèges" />
                </ListItem>
              </NavLink>
              <NavLink
                to="/assets/prod/read/1"
                style={{ textDecoration: 'none' }}
              >
                <ListItem
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: 0,
                  }}
                >
                  <ListItemAvatar>
                    <Avatar
                      alt="Fontanelles"
                      src={windTurbineIcon}
                      className={classes.avatar}
                    />
                  </ListItemAvatar>
                  <ListItemText secondary="Fontanelles" />
                </ListItem>
              </NavLink>
              <NavLink
                to="/assets/prod/read/2"
                style={{ textDecoration: 'none' }}
              >
                <ListItem
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: 0,
                  }}
                >
                  <ListItemAvatar>
                    <Avatar
                      alt="Eget"
                      src={hydroDamIcon}
                      className={classes.avatar}
                    />
                  </ListItemAvatar>
                  <ListItemText secondary="Eget" />
                </ListItem>
              </NavLink>
            </List>
          </Grid>
        </Grid>
        <Grid container spacing={24}>
          {this.renderTrackedAvoidedCo2Card()}
          {this.renderTotalAvoidedCo2Card()}
          {this.renderCo2EmissionsCard()}
        </Grid>
        <Paper className={classes.root}>
          <TransportCertificatesToolbar
            numSelected={selected.length}
            loading={this.props.loading}
            toggleFilter={this.props.toggleFilter}
            deliveries={transportCertificates}
            t={t}
            i18n={i18n}
          />
          <CSSTransitionGroup
            transitionName="example"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={300}
          >
            {this.props.showFilter ? this.renderForm() : false}
          </CSSTransitionGroup>
          <div className={classes.tableWrapper}>
            <Table className={classes.table} style={{ minWidth: 0 }}>
              <TransportCertificatesHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={this.handleSelectAllClick}
                onRequestSort={this.handleRequestSort}
                rowCount={transportCertificates.length}
                t={t}
                i18n={i18n}
              />

              <TableBody>
                {transportCertificates
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((transportCertificate, index) => {
                    const isSelected = this.isSelected(transportCertificate.id);

                    return (
                      <TableRow
                        hover
                        onClick={event => this.handleClick()}
                        role="checkbox"
                        aria-checked={isSelected}
                        tabIndex={-1}
                        key={index}
                        selected={isSelected}
                      >
                        <TableCell numeric>
                          {transportCertificate['Bon de livraison']}
                        </TableCell>
                        <TableCell>{transportCertificate.date}</TableCell>
                        <TableCell>{transportCertificate.Produit}</TableCell>
                        <TableCell numeric>
                          {transportCertificate.co2SavedTemp > 0 &&
                          transportCertificate.co2SavedTemp < 1
                            ? parseFloat(
                                transportCertificate.co2SavedTemp
                              ).toFixed(4)
                            : parseInt(
                                transportCertificate.co2SavedTemp,
                                10
                              ).toLocaleString()}
                        </TableCell>
                        <TableCell numeric>
                          {transportCertificate.co2SavedGoo > 0 &&
                          transportCertificate.co2SavedGoo < 1
                            ? parseFloat(
                                transportCertificate.co2SavedGoo
                              ).toFixed(4)
                            : parseInt(
                                transportCertificate.co2SavedGoo,
                                10
                              ).toLocaleString()}
                        </TableCell>
                        <TableCell numeric>
                          {transportCertificate.co2Emissions > 0 &&
                          transportCertificate.co2Emissions < 1
                            ? parseFloat(
                                transportCertificate.co2Emissions
                              ).toFixed(4)
                            : parseInt(
                                transportCertificate.co2Emissions,
                                10
                              ).toLocaleString()}
                        </TableCell>
                        <TableCell>
                          {transportCertificate['__EMPTY_1']}
                        </TableCell>
                        <TableCell>
                          {transportCertificate.curstomerSiteId}
                        </TableCell>
                        <TableCell>
                          {transportCertificate.curstomerSiteCity}
                        </TableCell>
                        <TableCell>
                          {transportCertificate['__EMPTY_3']}
                        </TableCell>
                        <TableCell>
                          {transportCertificate.curstomerId}
                        </TableCell>
                        <TableCell>
                          <Button
                            onClick={event =>
                              this.handleDownloadPdf(transportCertificate)
                            }
                          >
                            <img
                              src={certificateLogo}
                              alt="Download certificate"
                              title={t('Download certificate')}
                              style={{ width: 24, height: 24 }}
                            />
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}

                {emptyRows > 0 && (
                  <TableRow style={{ height: 49 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            component="div"
            count={transportCertificates.length}
            labelDisplayedRows={({ from, to, count }) =>
              from + '-' + to + t(' of ') + count
            }
            labelRowsPerPage={t('RowsPerPage')}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    );
  }
}

TransportCertificates.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({
  transportCertificatesReducer,
  router,
  loginReducer,
}) => {
  const {
    transportCertificates,
    transportCertificatesComplete,
    loading,
    order,
    orderBy,
    selected,
    page,
    rowsPerPage,
    filterText,
    filterDateText,
    filterProductText,
    filterShText,
    filterSpText,
    showFilter,
    dialogStartDateOpen,
    startDate,
    dialogEndDateOpen,
    endDate,
  } = transportCertificatesReducer;
  const { location } = router;
  const { isAuthenticated, username } = loginReducer;
  return {
    transportCertificates,
    transportCertificatesComplete,
    loading,
    order,
    orderBy,
    selected,
    page,
    rowsPerPage,
    filterText,
    filterDateText,
    filterProductText,
    filterShText,
    filterSpText,
    showFilter,
    location,
    isAuthenticated,
    username,
    dialogStartDateOpen,
    startDate,
    dialogEndDateOpen,
    endDate,
  };
};

const mapDispatchToProps = {
  getTransportCertificatesStart,
  sortTransportCertificates,
  changePageTransportCertificates,
  changeRowsPerPageTransportCertificates,
  filterDateTextChanged,
  filterProductTextChanged,
  filterTextChanged,
  filterSpTextChanged,
  filterShTextChanged,
  toggleFilter,
  toggleStartDateDialog,
  toggleEndDateDialog,
  setStartDate,
  setEndDate,
  generateTransportCertificatePdf,
};

TransportCertificates = withStyles(styles, { name: 'TransportCertificates' })(
  TransportCertificates
);
TransportCertificates = translate('translations')(TransportCertificates);
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TransportCertificates)
);



// WEBPACK FOOTER //
// ./src/components/TransportCertificates.js